export default class DocumentoPresolicitud {
    constructor(
        public numeroSolicitud?: number,
        public secuenciaDocumento?: number, 
        public tipoDocumento?: string,
        public ruta?: string,
        public requiereCambioDoc?: boolean,
        public esAdicional?: boolean,
        public accion?: string,
        public desRequisito?: string,
        public motivosRechazo?: Array<{ motivoRechazo: string }>,
        public codBeneficiario? : string,
        public codEtapa?:number

    ) {}
}